'use strict';
import 'core-js/client/shim';
let bootstrapApp = require('bootstrap_app');
import 'angular';
import 'angular-load';

import {bundle} from 'ng-metadata/core';
import {getBackendSystem} from "./appConfig/appConfigForward";
import {PrimoExploreModule} from './primoExplore/primoExploreModule';
import * as angular1 from 'angular';
const injector = angular1.injector(['ng']);
const $http: ng.IHttpService = injector.get('$http');

var angular:angular.IAngularStatic =  require('angular');
bootstrapApp.bootstrapConfiguration().then((res) => {
	
		getCitationConfiguration();
        if(window.location.search.indexOf('noCustomization=true')>-1) {
            return angular.bootstrap( document.querySelector('primo-explore'), [bundle(PrimoExploreModule).name] )
        }


        let deps = [];
        let centralModule, viewModule;
        if(res[0]) {
            try {
                centralModule = angular.module('centralCustom');
            } catch(err) {
            }
        }
        if(centralModule) {
            deps.push('centralCustom')
        }

        if(res[1]) {
            try {
                viewModule = angular.module('viewCustom');
            } catch(err) {
            }
        }

        if(viewModule) {
            deps.push('viewCustom');
        }

        return angular.bootstrap( document.querySelector('primo-explore'), [bundle(PrimoExploreModule, deps).name] );


    }
);

function getVidFromLocationBar() {
    return getParameterByName('vid', window.location.search) || getParameterByName('vid', window.location.hash);
}

function getParameterByName(name, searchString) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    let results = regex.exec(searchString);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function getFulldisplayVidParameterFromURL() {
    const pathSegments = window.location.pathname.split('/');
    const vid = pathSegments[pathSegments.length - 1];
    console.log('Extracted vid:', vid);
    return vid;
}

function getDeliveryVidParameterFromURL() {
    
    if ( isNaN(Number( window.location.pathname.split('/')[3]))) {
        return (window.location.pathname) ? window.location.pathname.split('/')[3] : '';
   }

	return '';
}

function getCitationConfiguration() {
	let vid = getVidFromLocationBar();
    if (!vid && window.location.pathname.indexOf('openurl') !== -1 && window.location.href.indexOf('&amp;vid=') !== -1 ) {
        let newLocation = window.location.href.replace(/&amp;/g, '&');
        window.location.assign(newLocation);        
    }
    
    // For google SEO in order to identify short fulldisplay url
    if (!vid && window.location.pathname.indexOf('fulldisplay') !== -1) {
        vid = getFulldisplayVidParameterFromURL();
    }

    if (!vid && window.location.pathname.indexOf('delivery') !== -1) {
        vid = getDeliveryVidParameterFromURL();
    }

	let url = getCitationConfigUrl(vid); 
	if(!vid || !url) {
		return;
	}
	$http({
			method: 'GET',
			url: url
	}).then((response) => {
		window.appConfig.citations = response.data;
	});
 
}

function getCitationConfigUrl(vid) {
    let restUrlPrimoExplore = '/primo_library/libweb/webservices/rest/v1/configuration/';
    let restUrlSuprima = '/primaws/rest/pub/cslFiles/vid/';
    let restUrl = getBackendSystem() === 'suprima'? restUrlSuprima : restUrlPrimoExplore;
    return window.location.protocol + '//' + window.location.host + restUrl + vid+ ((getBackendSystem() === 'suprima') ? '' : '/cslFiles');
}





// WEBPACK FOOTER //
// ./src/main/webapp/components/app.ts